import { useState, useEffect, useRef } from "react";
import { useAuth } from "hooks/Auth";
import LoaderShell from "components/LoaderShell";
import { oauthDel } from "helpers/Request";
import {
    removeOauthRefreshToken,
    removeOauthToken,
    removePublicationUuid,
    removePublicationCode,
} from "helpers/Auth";
import MainLayout from "./MainLayout";

export default function ApplicationShell({ children, ...props }) {
    const [appLoaded, setAppLoaded] = useState(false);

    const auth = useAuth();
    const startRef = useRef(false);

    const requestLogout = () => {
        setAppLoaded(false);

        oauthDel("api/v2/me").then((res) => {
            removeOauthRefreshToken();
            removeOauthToken();
            window.location.href =
                process.env.REACT_APP_OAUTH_SERVER + "/auth/v2/deauthenticate";
        });
    };
    const requestPublicationChange = () => {
        removePublicationUuid();
        removePublicationCode();
        window.location.reload();
    };

    // only fire this once
    useEffect(() => {
        if (startRef.current === false && auth.isAuthenticated) {
            startRef.current = true;
            console.info("Initialize singleton store");
            setTimeout(() => {
                setAppLoaded(true);
            }, 1);
        }

        return () => {
            startRef.current = false;
            setAppLoaded(false);
        };
    }, [auth.isAuthenticated]);

    if (!appLoaded) {
        return <LoaderShell />;
    }

    return (
        <div>
            <MainLayout
                user={auth.user}
                requestPublicationChange={requestPublicationChange}
                requestLogout={requestLogout}
            >
                {children}
            </MainLayout>
        </div>
    );
}
